export const LOCATIONS_LOADED_FAIL = 'app/LocationsProvider/LOCATIONS_LOADED_FAIL';
export const LOCATIONS_LOADED_SUCCESS = 'app/LocationsProvider/LOCATIONS_LOADED_SUCCESS';
export const LOAD_LOCATIONS = 'app/LocationsProvider/LOAD_LOCATIONS';
